import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiveDispatchTableData } from '../LiveDispatchTableData';
import { LiveDispatchTableDataProps } from '../../types';

export const LiveDispatchTableDataTaskType = ({
    data,
    className,
    'data-testid': dataTestId
}: LiveDispatchTableDataProps<string>) => {
    const { t } = useTranslation(['liveDispatchTable']);
    const taskType = data && t(`taskType.${data}`);

    return (
        <LiveDispatchTableData
            data={taskType}
            className={className}
            data-testid={dataTestId}
        />
    );
};
